import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IMaskModule } from 'angular-imask';
import { PessoaModule, SharedModule } from 'eddydata-lib';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { FieldsetModule } from 'primeng/fieldset';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ToastModule } from 'primeng/toast';
import { InventarioSecretariaRptRoutingModule } from './inventario-secretaria-rpt-routing.module';
import { InventarioSecretariaRptComponent } from './inventario-secretaria-rpt.component';

@NgModule({
  declarations: [InventarioSecretariaRptComponent],
  imports: [
    CommonModule,
    InventarioSecretariaRptRoutingModule,
    SharedModule,
    FormsModule,
    AutoCompleteModule,
    AccordionModule,
    IMaskModule,
    ToastModule,
    FieldsetModule,
    PessoaModule,
    CalendarModule,
    RadioButtonModule,
  ],
  exports: [
    InventarioSecretariaRptComponent,
  ],
  providers: []
})
export class InventarioSecretariaRptComponentModule { }
